import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { IzvestajBaseComponent } from '../izvestaj-base/izvestaj-base.component';
import {
  BackendService,
  TableSettings,
  FieldStructure,
  NotificationService,
  ListService,
} from 'beyond-util';
import { ReportService } from '../../../services/report.service';
import { EndpointTypeEnum } from '../../../enums/endpoint-type.enum';
import { ReportNameEnum } from '../../../enums/report-name.enum';
import * as moment from 'moment';
import { DEFAULT_DATE_FORMAT } from '../../../constants/date-format';
import { MimeFileType } from '../../../enums/mime-file-type.enum';
import { UtilServiceClient } from '../../../services/util.service';
import { BackendService as RtsBackendService } from '../../../services/backend.service';
import { FormCode } from '../../../enums/form-code.enum';
import { FormName } from '../../../enums/form-name.enum';
import { EndpointTypes } from '../../../enums/enpoint-types.enum';
import { RequestTypeEnum } from '../../../enums/request-type.enum';
import { IzvestajSettings } from '../prihodi-po-emisijama/izvestaj-settings.service';
import { isUndefined } from 'util';
import { EnumItem } from 'beyond-util/src/app/shared/services/list.service';

@Component({
  selector: 'app-izvestaj-za-pgp-i-muzicku-produkciju',
  templateUrl: './izvestaj-za-pgp-i-muzicku-produkciju.component.html',
})
export class IzvestajZaPgpIMuzickuProdukcijuComponent
  extends IzvestajBaseComponent
  implements OnInit {
  public klijenti: EnumItem[] = [];
  public canGenerate = true;
  public report: any = {};

  constructor(
    protected _backendService: BackendService,
    protected reportService: ReportService,
    protected notificationService: NotificationService,
    protected _rtsBackendService: RtsBackendService,
    protected _listService: ListService,
    protected utilService: UtilServiceClient,
    private _spinner: NgxSpinnerService,
    private izvestajStaticDataService: IzvestajSettings
  ) {
    super(_backendService);
    this._spinner.show();
    this.getSettings();
    this.getKlijenti();
    this.registarMesecEnum();
    this.refresh();
    this.name = 'Izveštaj za besplatna emitovanja';
  }

  ngOnInit() {
    super.ngOnInit();
  }

  refresh() {
    const date = new Date();
    const godina = date.getFullYear();

    this.orderList = [];
    this.report = {
      Mesec: null,
      Godina: godina,
      ProgramId: null,
      Klijenti: [],
    };
  }

  registarMesecEnum() {
    this._listService.registerEnum(
      'MSIZV_PGP_MesecEnum',
      this.izvestajStaticDataService.meseci
    );
  }

  getKlijenti() {
    this._rtsBackendService
      .fetchSettings(
        FormCode.MSKLI_BESP_EMI,
        FormName.BesplatnaEmitovanja,
        EndpointTypes.AllEntities,
        '',
        null,
        true
      )
      .subscribe(response => {
        const klijenti = this.getResponseData(response);

        if (klijenti && klijenti.length) {
          this.klijenti = klijenti.map(i => {
            return {
              value: i.Id,
              label: i.NazivImePrezime,
            };
          });

          this._listService.registerEnum(
            'MSIZV_PGP_KlijentiEnum',
            this.klijenti
          );
        }

        this._spinner.hide();
      });
  }

  getSettings() {
    const req = this.reportService.getSettingsPayload(
      ReportNameEnum.PGP,
      EndpointTypeEnum.Settings,
      FormCode.MSIZV_PGP
    );

    this.reportService.getSettings(req).subscribe(s => {
      this.splitDetails(s);
      this.fetchProgrami();
      this._listService.enumItemsSet.subscribe(prog => {
        this.fieldStructure = new FieldStructure(s, 'header');
        this.settingsTable = new TableSettings(s.details[0], 'table');
        this.settingsTableSource.next(this.settingsTable);
        this._spinner.hide();
      });
    });
    this._spinner.hide();
  }

  fetchProgrami() {
    this._rtsBackendService
      .fetchSettings(
        FormCode.MSPRO_PRO,
        FormName.PregledProgama,
        EndpointTypes.AllEntities
      )
      .subscribe(response => {
        const programi = response.ServiceData.Data;
        const parsed = this.utilService.parseEnum(programi);
        this._listService.registerEnum('MSIZV_PGP_ProgramIdEnum', parsed);
        this._spinner.hide();
      });
  }

  filter() {
    if (
      !this.report.Godina ||
      !this.report.Mesec ||
      !this.report.ProgramId ||
      !this.report.Klijenti.length
    ) {
      this.notificationService.notyError('Niste uneli sva obavezna polja.');

      return;
    }
    if (isNaN(this.report.Godina)) {
      this.notificationService.notyError('Polje Godina mora biti broj.');

      return;
    } else if (this.report.Godina < 1900 || this.report.Godina > 2500) {
      this.notificationService.notyError('Godina nije validna');

      return;
    }

    const request = this.reportService.getPayload(
      null,
      this.report,
      FormCode.MSIZV_PGP,
      ReportNameEnum.PGP,
      EndpointTypeEnum.Form,
      RequestTypeEnum.Post
    );

    this.reportService.getFormData(request).subscribe(res => {
      this._spinner.hide();
      this.orderList = this.getResponseData(res);
      if (!(this.orderList.length > 0)) {
        this.notificationService.notyError(
          'Ne postoji ni jedna verifikovana stavka za zadati period datuma.'
        );

        this.canGenerate = false;
      } else {
        this.canGenerate = true;
      }
      this.documentListSource.next(this.orderList);
    });
  }

  valueChanged(event) {
    if (event.newValue) {
      this.canGenerate = false;
    }
  }

  onToolbarActionExport() {
    if (!this.orderList.length || !this.canGenerate) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const payload = this.reportService.getPayload(
      '',
      this.getDocumentObject(),
      FormCode.MSIZV_PGP,
      ReportNameEnum.PGP,
      EndpointTypeEnum.Xls
    );

    this.reportService.exportToDocument(payload).subscribe(xlsx => {
      ReportService.downloadBlob(
        xlsx,
        MimeFileType.Xlsx,
        this.getExcelFileName(
          `Izveštaj_besplatna_emitovanja_${this.getDocumentObject().NaziviKlijenata.replace(
            ',',
            '-'
          )}`
        )
      );
    });
  }

  getDocumentObject() {
    const mesec = this.izvestajStaticDataService.meseci.find(
      m => m.value === this.report.Mesec
    ).label;

    const godina = this.report.Godina;
    const odabraniKlijenti = this.report.Klijenti;

    return {
      Mesec: mesec,
      Godina: godina,
      Data: this.orderList,
      NaziviKlijenata: this.klijenti
        .filter(k => odabraniKlijenti.includes(k.value))
        .map(k => k.label)
        .join(','),
    };
  }

  onToolbarActionPrint() {
    if (!this.orderList.length || !this.canGenerate) {
      this.notificationService.notyError(
        'Ne možete kreirati izveštaj bez podataka!'
      );

      return;
    }

    const payload = this.reportService.getPayload(
      '',
      this.getDocumentObject(),
      FormCode.MSIZV_PGP,
      ReportNameEnum.PGP,
      EndpointTypeEnum.Pdf
    );

    this.reportService.exportToDocument(payload).subscribe(pdf => {
      ReportService.openBlob(pdf, MimeFileType.Pdf);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/izvestaji/izvestaj-za-pgp-i-muzicku-produkciju/izvestaj-za-pgp-i-muzicku-produkciju.component.ts